"use strict";
"use es6";
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var EmptyError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(EmptyError, _Error);

  function EmptyError() {
    var _this;

    (0, _classCallCheck2.default)(this, EmptyError);

    var err = _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmptyError).call(this, 'no elements in sequence'));

    _this.name = err.name = 'EmptyError';
    _this.stack = err.stack;
    _this.message = err.message;
    return _this;
  }

  return EmptyError;
}((0, _wrapNativeSuper2.default)(Error));

exports.EmptyError = EmptyError;